import React, { useEffect, useState } from 'react';
import { Loader } from '../Common/Loader/loader';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Box, Button, Typography, Container } from '@mui/material';
import CareersMessageModal from '../Common/CareersMessageModal/careersMessageModal';
import useAuthentication from '../../Infrastructure/States/onAuthStateChange';
import { fetchJobListings } from '../../Infrastructure/States/jobListingsSlice';
import { ref, update } from "firebase/database";
import { database } from '../../Infrastructure/config';
import paths from '../../Infrastructure/Router/paths';
import { FaArrowLeft } from 'react-icons/fa';
import { jobLisitingSx } from './styles';

export const JobListing = () => {
  const { req } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation()
  const { user } = useAuthentication();
  const [job, setJob] = useState(null);
  const [open, setOpen] = useState(false);
  const userData  = useSelector(state => state.userData.data);
  const { jobsData, loading } = useSelector(state => state.jobs);

  useEffect(() => {
    if (loading) return
    const isValidJobsArray = Array.isArray(jobsData)
    const allJobs = isValidJobsArray
      ? jobsData.flatMap(category => Array.isArray(category.jobs) ? category.jobs : [])
      : []
    if (isValidJobsArray && allJobs.length === 0) {
      navigate(paths.careersPage.path)
      return
    }
    const foundJob = allJobs.find(job => String(job.req) === String(req));
  
    if (foundJob) {
      setJob(foundJob);
    } else if (!loading && isValidJobsArray) {
      navigate(paths.careersPage.path);
  }
  }, [req, jobsData, loading, navigate]);

  useEffect(() => {
    dispatch(fetchJobListings());
  }, [dispatch]);

  if (loading || !job) {
    return (
      <Loader height='100vh' />
    );
  }

  const handleApply = async () => {
    if (user && !userData?.is_educator) {
      setOpen(true);
    } else if (user && userData?.educator?.onboarding_complete) {
      setOpen(true);
    } else if(user && !userData?.educator?.onboarding_complete) {
        const userRef = ref(database, `users/${user.uid}`);
        await update(userRef, { req_id: job.req });
        navigate(paths.onboardingPage.path, {
        state: { from: location.pathname ,fromJob: true, title: job.title, subtitle: job.subtitle, req: job.req }
      });
    }else{
      navigate(paths.onboardingPage.path, {
        state: { from: location.pathname ,fromJob: true, title: job.title, subtitle: job.subtitle, req: job.req }
      });
    }
  };

  return (
    <Container maxWidth="md" sx={jobLisitingSx.jobListingContainer}>
      <CareersMessageModal open={open} setOpen={setOpen} />
      <Box sx={jobLisitingSx.backButton} onClick={()=> navigate('/careers')}>
        <FaArrowLeft />
      </Box>
      <Typography sx={jobLisitingSx.jobTitle} gutterBottom>
        {job?.title}{job.subtitle ? ` - ${job.subtitle}` : ""}
      </Typography>
      <Typography sx={jobLisitingSx.jobSubheading} gutterBottom color="textSecondary">
        {job?.subheading || ""}
      </Typography>
      <Typography sx={jobLisitingSx.jobLocationText} color="textSecondary">
        {job?.location || ""}
      </Typography>
      <Box mt={2} display={'flex'} justifyContent={'space-between'}>
        <Box/>
        <Typography variant="body1" color="initial">Req # {job?.req}</Typography>
      </Box>
      <Box mt={4}>
        <Typography sx={jobLisitingSx.descriptionTitle}>
          Description
        </Typography>
        <Typography sx={jobLisitingSx.descriptionBody} dangerouslySetInnerHTML={{ __html: job?.body }} />
      </Box>

      <Box sx={jobLisitingSx.applyButtonBox}>
        <Button variant="contained" color="primary" onClick={handleApply}>
          Apply Now
        </Button>
      </Box>
    </Container>
  );
};
